import { Badge } from "@/components/ui/badge";

const SENS_STYLES = {
  Public: "border-emerald-500/40 text-emerald-400 bg-emerald-500/10",
  Internal: "border-sky-500/40 text-sky-400 bg-sky-500/10",
  Confidential: "border-amber-500/40 text-amber-400 bg-amber-500/10",
  Restricted: "border-red-500/50 text-red-400 bg-red-500/10",
};

const LIFE_STYLES = {
  Draft: "border-border/70 text-muted-foreground bg-muted/40",
  Active: "border-accent/50 text-accent bg-accent/10",
  Deprecated: "border-red-500/40 text-red-400/80 bg-red-500/5 line-through",
};

export function SensitivityBadge({ value }) {
  if (!value) return null;
  return (
    <Badge
      variant="outline"
      className={`rounded-full px-2 py-0 text-[10px] uppercase tracking-[0.12em] ${SENS_STYLES[value] || ""}`}
    >
      {value}
    </Badge>
  );
}

export function LifecycleBadge({ value }) {
  if (!value) return null;
  return (
    <Badge
      variant="outline"
      className={`rounded-full px-2 py-0 text-[10px] uppercase tracking-[0.12em] ${LIFE_STYLES[value] || ""}`}
    >
      {value}
    </Badge>
  );
}
